<template>
    
    <div v-if="!sharedStore.loading" class="retailers-list" :style="{height: height}">
        <div v-if="sharedStore.searched && (!sharedStore.retailers || sharedStore.retailers.length == 0)" class="retailers-list__no-results">No results found.</div>
        <div v-if="sharedStore.retailers && sharedStore.retailers.length >= 1" class="retailers-list__results-table">
            
            <div v-for="r in sharedStore.retailers" :id="r.Id" :key="r.Id" class="retailers-list__row">
                <!-- <div class="brand-indicator" :class="r.dealership.brand.replaceAll(' ', '-').toLowerCase()"></div> -->
                <div>
                    <div class="retailers-list__row-col">
                        <div class="retailer-list--dealer">  <b>{{ r.dealership.dealerName }}</b>  </div>
                        <div class="retailer-list--brand">{{ brandName( r.dealership.brand ) }} </div>
                        <div>
                            <a :href="r.dealership.dealershipAttributes.website" target="_blank" @click="trackClick(r.result, 'retailer-website')">{{ r.dealership.dealershipAttributes.website }}</a>
                        </div>
                        <div>
                            <a :href="'tel:' + r.dealership.shippingPhone" @click="trackClick(r.result, 'retailer-phone')">{{ r.dealership.shippingPhone }}</a>
                        </div>
                    </div>
                    <div class="retailers-list__row-col">
                        <div>
                            <!-- eslint-disable-next-line -->
                            <!-- <span v-html="r.result.addressHtml" /> -->
                            {{ r.dealership.shippingAddress1 }}
                            <span v-if="r.dealership.shippingAddress2 !== NULL"><br />{{ r.dealership.shippingAddress2 }}</span>
                            <br />{{ r.dealership.shippingCity }}, {{ r.dealership.shippingStateProv }} {{ r.dealership.shippingZip }}
                        </div>
                        <div>
                            <span>{{ Math.round(r.distance) }} miles</span>&nbsp;
                            <a :href="directionsLink(r.dealership)" target="_blank" @click="trackClick(r.result, 'retailer-map-directions')">Directions</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>Here{{sharedStore}}</div>
</template>

<script>
import {store} from '../store';

export default {
    name: 'RetailersList',
    props: {
        height: {
            type: String,
            required: false,
            default: '100vh', // 400,
        },
    },
    data: () => {
        return {
            sharedStore: store.state,
        };
    },
    methods: {
        directionsLink(location) {
            const base = 'https://www.google.com/maps/place/';
            let query = [ location.shippingAddress1, location.shippingCity, location.shippingStateProv ].join(',');
            return `${base}${query}`.replaceAll(" ", "+");
        },
        brandName( brand ) {
            const brands = [
                { 
                    "brand" : "Case",
                    "display" : "CASE Construction Equipment Dealer"
                },
                {
                    "brand" : "Case IH",
                    "display" : "Case IH Dealer"
                },
                {
                    "brand" : "New Holland AG",
                    "display" : "New Holland Dealer"
                }
            ];
            const title = brands.filter( item => item.brand == brand )
            return title[0].display;
        },
        trackClick(retailer, actionMessage) {
            if (window.gtag) {
                window.gtag('event', 'retailer-external-link', {event_category: actionMessage, event_label: retailer.name + ' - ' + retailer.id});
            }

            // if (window.dataLayer) {
            //     // google tag manager
            //     window.dataLayer.push({
            //         event: 'retailer-external-link',
            //         action: actionMessage,
            //         'results-found': retailer.name + ' - ' + retailer.id,
            //     });
            // } else if (window.ga) {
            //     // google analytics
            //     window.ga('send', 'event', 'retailer-external-link', actionMessage, retailer.name + ' - ' + retailer.id);
            // }
        },
    },
};
</script>

<style lang="scss">
.retailers-list {
    //margin: 1rem auto;
    font-size: 0.9rem;

    &__no-results {
        color: #300;
    }

    &__row {
        display: flex;
        // flex-direction: row;
        padding: 1rem 0;

        justify-content: flex-start;

        background-color: #fff;
        &:nth-child(even) {
            background-color: #eff4f5;
        }

        &-col {
            flex-basis: 50%;
            padding: 0 1rem;

            &.title {
                display: flex;
            }
        }
        @media screen and (max-width: 600px) {
            flex-direction: column;
            &-col {
                flex-basis: 100%;
            }
        }
    }

    &__header {
        font-weight: bold;
        font-size: 1.1rem;
        border-bottom: 1px solid #ccc;
        background-color: none;
        padding-bottom: 0;

        @media screen and (max-width: 600px) {
            display: none;
        }
    }

    .brand-indicator {
        width: 2rem;
        height: 2rem;
        margin-left: 1rem;
        
        &.case {
            background: #992935;
        }
        
        &.case-ih {
            background: #2B4089;
        }
        
        &.new-holland-ag {
            background: #F19F3B;
        }
    }
}
</style>
